import { render, staticRenderFns } from "./business.pug?vue&type=template&id=edd4eefc&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./business.scss?vue&type=style&index=0&id=edd4eefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd4eefc",
  null
  
)

export default component.exports